import * as React from "react";
import { css } from "@emotion/core";
import styled from "@emotion/styled";
import {Link} from "@fitplan/lib/components/Link";

import { getAthleteName } from "../../utils/helpers";

const forPhoneOnly = "599px";
const forTabletPortraitUp = "600px";
const forDesktopUp = "1200px";

export interface Props {
    url: string;
    slug: string;
    planName: string;
    daysCount: number;
    component: string;
    firstName: string;
    lastName: string;

    planImage: string;
}

const PlanCard: React.SFC<Props> = props => {
    return (
        <Link to={`/plans/${props.url}`} key={props.planName} css={cardCss}>
            <Container>
                <Image src={props.planImage} className="plans__card-image" />
                <Overlay />
                <Text>
                    <Name>{getAthleteName(props, true)}</Name>
                    <Title>{props.planName}</Title>
                </Text>
            </Container>
        </Link>
    );
};

export default PlanCard;

const Container = styled.div`
    width: 100%;
    position: relative;
    margin-bottom: -6px;
`;

const Image = styled.img`
    width: 100%;
`;

const Name = styled.div`
    font-family: $barlow;

    line-height: 1.41;
    text-align: left;
    font-size: 17px;
    margin-bottom: 8px;
`;

const Title = styled.div`
    font-family: Barlow Condensed, sans-serif;
    font-size: 28px;
    font-weight: bold;
    width: 90%;
    line-height: 1.25;
    @media (min-width: ${forDesktopUp}) {
        line-height: 1.19;
    }

    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

const Text = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    margin-bottom: 16px;
    margin-left: 16px;
    z-index: 2;
    color: white;
    text-align: left;

    @media (max-width: ${forPhoneOnly}) {
        width: 60%;
    }
    @media (min-width: ${forTabletPortraitUp}) {
        width: 60%;
    }
    @media (min-width: ${forDesktopUp}) {
        width: 40%;
    }
`;

const Overlay = styled.div`
    position: absolute;
    height: 75%;
    width: 100.5%;
    bottom: -3px;
    opacity: 0.7;
    background-image: linear-gradient(
        -180deg,
        rgba(0, 0, 0, 0) 15%,
        #000000 100%
    );
    z-index: 1;

    &:hover ~ ${Text} {
        color: #00ffb3;
    }
`;

const cardCss = css`
    position: relative;
    overflow: hidden;
    text-decoration: none;

    @media (max-width: ${forPhoneOnly}) {
        width: 100%;
        height: 100%;
    }

    @media (min-width: ${forTabletPortraitUp}) {
        width: 48%;
    }

    @media (min-width: ${forDesktopUp}) {
        width: 33.33%;
    }

    &:hover ${Overlay} {
        opacity: 0.9;
        background-image: linear-gradient(
            -180deg,
            rgba(0, 0, 0, 0) 15%,
            #000000 100%
        );
    }

    &:hover ${Text} {
        color: #00ffb3;
    }
`;
